export default {"src":"/_next/static/media/full_logo_white.58f325ba.svg","height":58,"width":136,"blurWidth":0,"blurHeight":0};